import type { ReactNode } from "react";

import { ScrollArea } from "@mantine/core";

import classes from "./GuidedFlowsPanel.module.css";

interface GuidedFlowsPanelProps {
    guide: ReactNode;
}

export function GuidedFlowsPanel({ guide }: GuidedFlowsPanelProps) {
    return (
        <ScrollArea pos="absolute" inset={0} scrollbars="y" classNames={{ content: classes.content }}>
            {guide}
        </ScrollArea>
    );
}
